<section class="mechanics-page">
  <aside class="brand-rail">
    <img src="assets/dashboard/logoApp.svg" alt="AutoInsight logo" class="brand-logo" />
  </aside>

  <main class="mechanics-panel">
    <div class="panel-head">
      <button type="button" class="back-btn" (click)="goBack()" aria-label="Back to schedule">&#8592;</button>
      <h1>Mechanics</h1>
    </div>

    <p class="mechanics-status" *ngIf="loading">Loading registered mechanics...</p>
    <p class="mechanics-status error" *ngIf="!loading && errorMessage">{{ errorMessage }}</p>
    <p class="mechanics-status" *ngIf="!loading && !errorMessage && mechanics.length === 0">
      No registered mechanics found.
    </p>

    <table class="mechanics-table" *ngIf="!loading && !errorMessage">
      <thead>
        <tr>
          <th>Name</th>
          <th>Contact</th>
          <th>Location</th>
          <th>Cost</th>
          <th>Rating</th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let mechanic of mechanics"
          [class.active]="selectedMechanic === mechanic.name"
          (click)="setSelectedMechanic(mechanic.name)">
          <td>{{ mechanic.name }}</td>
          <td>{{ mechanic.contact }}</td>
          <td>{{ mechanic.location }}</td>
          <td>{{ mechanicCostLabel(mechanic.name) }}</td>
          <td class="rating-cell">{{ mechanicRatingLabel(mechanic.name) }}</td>
        </tr>
      </tbody>
    </table>

    <button type="button" class="select-btn" (click)="confirmSelection()" [disabled]="!selectedMechanic">
      Select
    </button>
  </main>
</section>
